import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavLink,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap';
import slugify from 'react-slugify';

const DropDownOptions = (props) => {
    const heading = props.heading
    const dropDownLinkData = props.dropDownData
    const path = props.path
    // console.log('DropDownOptions Props',props)
    // console.log('DropDownOptions H',heading)
    // console.log('DropDownOptions P',path)
    // console.log('DropDownOptions D',dropDownLinkData)

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                {heading}
            </DropdownToggle>
            <DropdownMenu right className="dropleft">
                {dropDownLinkData.map((link, i) => (link.fields.navLinks
                    ? <DropDownOptions key={i} heading={link.fields.heading} path={path + '/' + slugify(heading)} dropDownData={link.fields.navLinks} />
                    : <DropdownItem>
                        <NavLink key={i} tag={Link} to={path + '/' + slugify(heading) + '/' + slugify(link.fields.heading)}>{link.fields.heading}</NavLink>
                    </DropdownItem>
                ))}
                {heading === "Treatments" && 
                    <DropdownItem divider />
                }
                {heading === "Treatments" && 
                    <DropdownItem>
                        <NavLink tag={Link} to={path + '/treatments'}>{"All Treatments"}</NavLink>
                    </DropdownItem>
                }
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

const MainNavBarOptions = (props) => (
    props.contentData[0].fields.navLinks.map((link, i) => (link.fields.navLinks
        ? <DropdownItem><DropDownOptions key={i} heading={link.fields.heading} path={''} dropDownData={link.fields.navLinks} /></DropdownItem>
        : <DropdownItem>
            <NavLink key={i} tag={Link} to={'/' + slugify(link.fields.heading)}>{link.fields.heading}</NavLink>
        </DropdownItem>
    ))
)

const Navigation = props => (
    <Navbar dark color="dark" expand="md" className="px-5">
        <NavbarBrand tag={Link} to="/" className="text-secondary">Zuri Beauty</NavbarBrand>
        <NavbarToggler onClick={props.onClick} />
        <Collapse isOpen={props.isOpen} navbar>
            <Nav className="ml-auto" navbar>
                {props.contentData && <MainNavBarOptions contentData={props.contentData} />}
            </Nav>
        </Collapse>
    </Navbar>
)
export default Navigation;